import React from 'react'
import styled from 'styled-components'

const ExtLink = ({ children, ...props }) => {
  return <OutboundLink {...props} target='_blank'>{children}</OutboundLink>
}

const OutboundLink = styled.a`
  text-shadow: none;
  background-image: none;
  width: 100%;
  height: 100%;
`

export default ExtLink
